const createItem = (text, params) => ({ text, params });

const vestuarioGroups = [
  "ALFAIATARIA",
  "BERMUDA",
  "BLAZER",
  "BLUSA",
  "BODY",
  "CALÇA",
  "CAMISA",
  "CAMISETA",
  "CARDIGAN",
  "CASACOS",
  "CASAQUETO",
  "COLETE",
  "CONJUNTOS",
  "JAQUETA",
  "JARDINEIRA",
  "JEANS",
  "KIMONO",
  "MACACÃO",
  "MALHAS",
  "MANTO",
  "PONCHO",
  "SAIA",
  "SAIDA DE PRAIA",
  "SHORT",
  "SHORT SAIA",
  "SUETER",
  "TOP",
  "VESTIDOS",
];

const calcadosGroups = [
  "SAPATOS",
  "BOTA",
  "SANDALIA",
  "SAPATILHA",
  "SCARPIN",
  "TENIS",
  "RASTEIRA",
  "ANKLE BOOT",
];

const acessoriosGroups = [
  "BOLSA",
  "CINTO",
  "CHAPEU",
  "LENÇO",
  "OCULOS",
  "ACESSORIOS",
  "BROCHE",
  "CACHECOL",
  "CARTEIRA",
  "CLUTCH",
  "ECHARPE",
  "MALA",
];

const ocasiaoFilters = ["Festa", "Neve", "Praia"];
const generoFilters = ["F", "M"];

export const shops = [
  {
    title: "VESTUÁRIO",
    items: [
      createItem("Alfaiataria", { categoria: ["ALFAIATARIA"] }),
      createItem("Blazers", { categoria: ["BLAZER"] }),
      createItem("Blusas", { categoria: ["BLUSA"] }),
      createItem("Calças", { categoria: ["CALÇA"] }),
      createItem("Camisas", { categoria: ["CAMISA"] }),
      createItem("Casacos", { categoria: ["CASACOS"] }),
      createItem("Jeans", { categoria: ["JEANS"] }),
      createItem("Malhas", { categoria: ["MALHAS"] }),
      createItem("Saias", { categoria: ["SAIA"] }),
      createItem("Shorts", { categoria: ["SHORT", "SHORT SAIA"] }),
      createItem("Tops", { categoria: ["TOP"] }),
      createItem("Vestidos", { categoria: ["VESTIDOS"] }),
      createItem("VER TUDO", { categoria: vestuarioGroups }),
    ],
  },
  {
    title: "CALÇADOS",
    items: [
      createItem("Botas", { categoria: ["BOTA"] }),
      createItem("Rasteiras", { categoria: ["RASTEIRA"] }),
      createItem("Sandálias", { categoria: ["SANDALIA"] }),
      createItem("Sapatilhas", { categoria: ["SAPATILHA"] }),
      createItem("Sapatos", { categoria: ["SAPATOS"] }),
      createItem("Scarpin", { categoria: ["SCARPIN"] }),
      createItem("Tênis", { categoria: ["TENIS"] }),
      createItem("Ankle Boot", { categoria: ["ANKLE BOOT"] }),
      createItem("VER TUDO", { categoria: calcadosGroups }),
    ],
  },
  {
    title: "ACESSÓRIOS",
    items: [
      createItem("Bolsas", { categoria: ["BOLSA"] }),
      createItem("Cintos", { categoria: ["CINTO"] }),
      createItem("Chapéus", { categoria: ["CHAPEU"] }),
      createItem("Lenços", { categoria: ["LENÇO"] }),
      createItem("Óculos", { categoria: ["OCULOS"] }),
      createItem("VER TUDO", { categoria: acessoriosGroups }),
    ],
  },
  {
    title: "OCASIÃO",
    items: [
      createItem("Festa", { ocasiao: ["Festa"] }),
      createItem("Neve", { ocasiao: ["Neve"] }),
      createItem("Praia", { ocasiao: ["Praia"] }),
      createItem("VER TUDO", { ocasiao: ocasiaoFilters }),
    ],
  },
  {
    title: "GENERO",
    items: [
      createItem("Feminino", { genero: ["F"] }),
      createItem("Masculino", { genero: ["M"] }),
      createItem("VER TUDO", { genero: generoFilters }),
    ],
  },
];
